import { Grid } from "@mui/material";
import React, { useState } from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import { orderData } from "../data";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useDispatch } from "react-redux";
import {
  resetDataComponent,
  updateDataComponent
} from "../../StateManagement/actions";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  Method,
  toTitleCase,
  TransactionPages
} from "../../commonFunctions/CommonFunctions";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import clientconfig from "../../Config/clientConfig.json";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import PermissionDenied from "../../commonFunctions/PermissionDenied";

export const DeliveredList: React.FC<any> = () => {
  const [orderId, setOrderID] = useState<any>();
  const { view, exports } = getPermissions(
    TransactionPages.DeliveredList,
    IRoleMain.Transactions
  );
  const [totalCount, setTotalCount] = useState<any>();
  const [filterChanged, setFilterChanged] = useState<any>(false);
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();

  const columns: IColumns[] = [
    {
      header: "Order#",
      fieldName: "orderNumber",
      type: "default",
      sortable: true,
      sortKey: "OrderNumber"
    },
    {
      header: "Name",
      fieldName: "customerName",
      type: "default"
      // sortable: true,
      // sortKey: "id"
    },

    { header: "Phone", fieldName: "phoneNumber", type: "default" },
    { header: "Is Home Delivery", fieldName: "homeDelivery", type: "default" },
    { header: "Status", fieldName: "orderStatus", type: "status" },
    {
      header: "Ordered On",
      fieldName: "orderDate",
      type: "date",
      sortable: true
    },
    {
      header: "Expected Delivery",
      fieldName: "deliveryDate",
      type: "date",
      sortable: true
    },
    {
      header: "Total Price",
      fieldName: "finalAmount",
      type: "default"
    }
    // {
    //   header: "Actions",
    //   fieldName: "actions",
    //   type: "action",
    //   actions: ["Add Payment"],
    //   actionCallback: (action, row) => handleAction(action, row)
    // }
  ];
  const filterRows: IRows[] = [
    {
      label: "Order#",
      fieldName: "OrderNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "CustomerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    },

    {
      label: "Phone Number",
      fieldName: "PhoneNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    }
  ];

  const handleFilterChange = (newFilters: any) => {
    dispatch(updateDataComponent("ordersGrid", { newFilters }));
    setFilterChanged(true);
    //setFilters(newFilters);
  };
  const source = {
    url: "orders/search",
    page: 1,
    pageSize: 10,
    filter: [
      { field: "OrderStatus", operator: "eq", value: "Delivered" },
      // {
      //   field: "FranchiseId",
      //   operator: "eq",
      //   value: getLocalValue(LoacalVariables.FranchiseId)
      // }
    ],
    sort: []
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    if (data && data?.length > 0) {
      data?.map((item: any) => {
        item.homeDelivery = item?.isHomeDelivery ? "Yes" : "No";
        item.status = toTitleCase(item.orderStatus);
      });
      return data;
    }
  };

  return (
    <>
      <HeaderList
        title="Deleverd"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="paymentGrid"
              title="Deleverd"
              headerType="HaderTopCornered"
              columns={columns}
              filterFields={filterRows}
              source={source}
              transFormData={transFormData}
              isFilterChanged={filterChanged}
              searchBox={{
                fieldName: "OrderNumber,CustomerName,PhoneNumber",
                bg: "white"
              }}
              exportCsv={exports}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
};
